import { Stack } from '@mui/material';
import { ICellRendererParams } from 'ag-grid-community';
import React from 'react';

import { GroupInfo } from '@/console/features/groups/components/group-list/group-info/group-info';
import { DeleteAssets } from '@/shared/features/assets/delete-assets/delete-assets';
import { GroupName } from '@/shared/features/groups/components/group-name/group-name';
import { GroupedItemContextMenu } from '@/shared/features/groups/components/grouped-item-context-menu/grouped-item-context-menu';
import { usePermissionCheck } from '@/shared/features/permissions/hooks/use-permission-check/use-permission-check';

export const GroupNameRenderer: React.FC<ICellRendererParams> = ({ data }) => {
  return (
    <Stack height="100%" justifyContent="center" alignItems="flex-start">
      <GroupName groupId={data.groupId} />
    </Stack>
  );
};

export const GroupItemContextMenuRenderer: React.FC<ICellRendererParams> = ({
  data,
}) => {
  if (!data?.raw) {
    return null;
  }

  return <GroupedItemContextMenu item={data.raw} />;
};

export const SubGroupContextMenuRenderer: React.FC<ICellRendererParams> = ({
  data,
}) => {
  const { can } = usePermissionCheck();
  const permissionToDelete = can(
    'resourceGroup:deleteResourceGroup',
    data.groupId,
  );

  const getDeleteMenuItem = (handleClose?: () => void) => {
    if (!permissionToDelete) {
      return null;
    }

    return (
      <DeleteAssets
        assets={[data.raw]}
        onSuccess={handleClose}
        component="MenuItem"
      />
    );
  };

  return (
    <Stack
      direction="row"
      gap="0.5rem"
      alignItems="center"
      justifyContent="flex-end"
      height="100%"
    >
      <GroupInfo groupId={data.groupId} />
      {data.raw && (
        <GroupedItemContextMenu
          item={data.raw}
          additionalDangerOptions={getDeleteMenuItem}
        />
      )}
    </Stack>
  );
};
